/*
 * fiore-pdp.js
 * Re-filters the Fiore editorial & campaign sections to the active colour.
 *
 * Strategy: every colour group is rendered server-side (all colours present in
 * product.media) and wrapped in [data-fiore-color="cN"]. Only the active
 * colour's groups are visible; the rest carry the `hidden` attribute. When the
 * shopper changes the colour variant we read the current variant id from the
 * product form's hidden [name="id"] input, map it to a colour code via the JSON
 * map printed by snippets/fiore-color-map.liquid, and toggle visibility.
 *
 * No server round-trip, so it is instant and CLS-free, and it is independent of
 * the Dawn version (works whether variant changes fire pub/sub events, re-render
 * the main section, or only mutate the hidden input).
 */
(function () {
  if (window.__fioreInit) return;
  window.__fioreInit = true;

  function readMap() {
    var el = document.getElementById('fiore-vcmap');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }
  var map = readMap();

  function currentVariantId() {
    var input = document.querySelector(
      'product-info form [name="id"], product-form form [name="id"], form[action*="/cart/add"] [name="id"]'
    );
    if (input && input.value) return String(input.value);
    var u = new URLSearchParams(window.location.search).get('variant');
    return u ? String(u) : null;
  }

  function currentColor() {
    var id = currentVariantId();
    if (id && map[id]) return map[id];
    var first = document.querySelector('[data-fiore-color]');
    return first ? first.getAttribute('data-fiore-color') : null;
  }

  function apply(code) {
    if (!code) return;
    // Toggle every colour group.
    var groups = document.querySelectorAll('[data-fiore-color]');
    for (var i = 0; i < groups.length; i++) {
      var on = groups[i].getAttribute('data-fiore-color') === code;
      groups[i].hidden = !on;
      groups[i].setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    // Hide a whole section when the active colour has no media in it.
    var sections = document.querySelectorAll('[data-fiore-section]');
    for (var s = 0; s < sections.length; s++) {
      var active = sections[s].querySelector('[data-fiore-color="' + code + '"]');
      // Editorial figures carry .fiore-media, campaign figures carry
      // .fiore-cmp__media — count both (any <figure> in the active group).
      var count = active ? active.querySelectorAll('.fiore-media, .fiore-cmp__media').length : 0;
      sections[s].hidden = count === 0;
    }
  }

  var last = null;
  function sync() {
    var c = currentColor();
    if (c && c !== last) { last = c; apply(c); }
  }

  function boot() { sync(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Instant reaction to interactions with the variant picker.
  document.addEventListener('change', function () { setTimeout(sync, 0); }, true);
  document.addEventListener('click', function () { setTimeout(sync, 0); }, true);
  // Dawn / storefront custom events, when present.
  document.addEventListener('variant:change', function () { setTimeout(sync, 0); });
  window.addEventListener('popstate', function () { setTimeout(sync, 0); });
  // Safety net for section-rendering swaps that don't bubble a usable event.
  setInterval(sync, 500);
})();
